<template>
  <div class="video-page-wrapper">
    <IphoneVideo :video-name="require('@/assets/videos/manage_rooms.mp4')"></IphoneVideo>
    <div class="video-page-texts">
      <div>
        <h3>{{ $t("pages.rooms.subtitle1") }}</h3>
        <p>{{ $t("pages.rooms.text1") }}</p>
      </div>
      <div>
        <h3>{{ $t("pages.rooms.subtitle2") }}</h3>
        <p>{{ $t("pages.rooms.text2") }}</p>
      </div>
      <div>
        <h3>{{ $t("pages.rooms.subtitle3") }}</h3>
        <p>{{ $t("pages.rooms.text3") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Rooms"
};
</script>

<style scoped lang="scss">
</style>
